import { Spotlight, SpotlightStore } from '@mantine/spotlight';
import { X } from 'lucide-react';
import { ReactNode } from 'react';

interface Props {
    id: string;
    children: ReactNode;
    query?: string;
    setQuery?: (query: string) => void;
    spotlightStore?: SpotlightStore;
    closeOnActionTrigger?: boolean;
    onSpotlightOpen?: () => void;
    spotLightUtils: {
        open: () => void;
        close: () => void;
        toggle: () => void;
    };
}

export const CustomSpotlight = ({
    id,
    children,
    query,
    setQuery,
    spotlightStore,
    spotLightUtils,
    closeOnActionTrigger,
    onSpotlightOpen,
}: Props) => {
    return (
        <Spotlight.Root
            id={id}
            query={query}
            closeOnClickOutside={false}
            closeOnActionTrigger={closeOnActionTrigger ?? true}
            onQueryChange={setQuery}
            store={spotlightStore}
            onSpotlightOpen={onSpotlightOpen}
            classNames={{
                body: 'relative',
                content: 'overflow-visible',
            }}
            // eslint-disable-next-line unicorn/no-null
            shortcut={null}
        >
            <X
                onClick={spotLightUtils.close}
                className="icon-bold absolute -right-2.5 -top-2.5 z-[420] size-8 cursor-pointer rounded-full bg-white p-1 shadow-md transition hover:scale-110 hover:shadow-lg"
            />
            {children}
        </Spotlight.Root>
    );
};
